module.exports = __webpack_public_path__ + "img/vertical_6_5_8003.69974c26.png";